import { Outlet } from "react-router-dom";

import { useAuth } from "@vellum/micro-app-auth";

import { getHubUrl } from "@/config";
import { isAdmin } from "@/lib/auth/roles";

/** Everything in this app is admin-only; non-admins get sent back to Hub. */
export function RequireAdmin() {
  const { user } = useAuth();

  if (!isAdmin(user)) {
    return (
      <div>
        <h1 className="mb-3 text-2xl font-bold text-green-700">
          Admin access required
        </h1>
        <p className="mb-4 max-w-xl text-sm text-gray-600">
          Vellum Admin manages facilities, companies, and users, and is limited
          to admin accounts.
        </p>
        <a
          href={getHubUrl()}
          className="font-medium text-blue-500 no-underline hover:underline"
        >
          Back to Hub
        </a>
      </div>
    );
  }

  return <Outlet />;
}
